export default __webpack_public_path__ + "static/media/main3_s.68e5e9bc.jpg";